// extracted by mini-css-extract-plugin
export default {"component":"RecordPairsFeedbackAssignButton-module__component___dx52z"};